import { Fragment } from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router";
import { useBreadcrumbs } from "./use-breadcrumbs";
import { DekoxIcon } from "src/components/deko-x-icons";

export const HeaderBreadcrumbs = () => {
  const breadcrumbs = useBreadcrumbs();
  const navigate = useNavigate();

  const theme = useTheme();

  if (breadcrumbs.length === 0) return null;

  return (
    <Stack direction="row" alignItems="center" gap={0.5}>
      {breadcrumbs.map((crumb, index) => (
        <Fragment key={crumb.label}>
          {index > 0 && <DekoxIcon icon="arrow-right" fontSize="small" />}
          <Typography
            variant="subtitle1"
            color={theme.palette.customColors.darkGrey}
            sx={crumb.path ? { cursor: "pointer", "&:hover": { textDecoration: "underline" } } : undefined}
            onClick={crumb.path ? () => crumb.path && navigate(crumb.path) : undefined}
          >
            {crumb.label}
          </Typography>
        </Fragment>
      ))}
    </Stack>
  );
};
